

export const soraFeatures = {
    title: '选择 Sora 2 的理由',
    sub: 'OpenAI 的 Sora 2 在 AI 视频生成领域取得突破。',
    items: [
      { num: '01', title: '高级物理模拟与真实运动', text: '极高物理精度与运动真实感，复杂场景中对象保持一致性。' },
      { num: '02', title: '双模式生成：文字转视频与图片转视频', text: '可从文字生成或将图片转为动态序列，保持画面一致性。' },
      { num: '03', title: '灵活输出与多比例', text: '最长 15 秒，横/竖版均可；高清渲染、平台优化。' },
      { num: '04', title: '精准创作控制与多样风格', text: '精细控制场景、动作与风格：写实、电影感或风格化均可。' }
    ]
  };
